import type { ColTypeDef } from 'ag-grid-community';
import { useMemo } from 'react';

import { QuoteModeCellRenderer } from '../CellRenderers';

export function useQuoteModeColumnType<T>(useSetColumnFilter?: boolean): ColTypeDef<T> {
  return useMemo(() => {
    const filter = useSetColumnFilter ? 'agSetColumnFilter' : 'agTextColumnFilter';
    return {
      cellRenderer: QuoteModeCellRenderer,
      filter,
    };
  }, [useSetColumnFilter]);
}
export function useServerSideQuoteModeColumnType<T>(): ColTypeDef<T> {
  return useMemo(
    () => ({
      cellRenderer: QuoteModeCellRenderer,
    }),
    [],
  );
}
